import React from 'react';

import { Heading, Text, VStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ScanningScheduleTable } from './components/scanning-schedule-table/scanning-schedule-table';

export const ScanningSchedule: React.FC = () => {
  const { t } = useTranslation('telemetryScannerConfig');
  const { scannerId } = useParams();

  return (
    <VStack width="full" gap="smedium">
      <Heading level="4" paddingY="xsmall">
        {t('scanningSchedule.title')}
      </Heading>
      <Text styledAs="body2" marginBottom="large">
        {t('scanningSchedule.subtitle')}
      </Text>
      <ScanningScheduleTable scannerId={scannerId ?? ''} />
    </VStack>
  );
};
